export enum DialogResult { Yes, No, Ok, Cancel }
export enum DialogButtons { Yes, No, Ok, Cancel }

/** Show dialog with a free content and buttons */
export class FixedDialog {
    static openedDialogs: FixedDialog[];

    protected parentContainer: HTMLElement;
    protected container: HTMLElement;
    protected content: HTMLElement;
    protected onWindowClick: any;
    protected marginLeft: number;
    protected marginTop: number;
    protected zindex?: number;
    protected deferrer: JQuery.Deferred<any, any, any>;
    protected showContent: Element;
    protected showContentParent: Element;

    /**
     * Constructor
     * @param toElement It is possible to align the dialog to some element on the page. If this parameter is defined, the dialog will be displayed near the element
     * @param modal Display the dialog on the modal background
     */
    constructor(
        protected toElement?: HTMLElement,
        protected modal?: boolean
    ) {
    }


    /**
     * Show dialog with button Ok
     * @param content Content to display. Can be text or some html element
     * @return Returns a JQueryPromise with a DialogResult. The Promise is rejected if the dialog is closed with a click outside the dialog
     */
    showOk(content: any, marginLeft?: number, marginTop?: number): JQueryPromise<DialogResult> {
        return this.show(content, [DialogButtons.Ok], marginLeft, marginTop);
    }

    /**
     * Show dialog with buttons Ok and Cancel
     * @param content Content to display. Can be text or some html element
     * @return Returns a JQueryPromise with a DialogResult. The Promise is rejected if the dialog is closed with a click outside the dialog
     */
    showOkCancel(content: any, marginLeft?: number, marginTop?: number): JQueryPromise<DialogResult> {
        return this.show(content, [DialogButtons.Ok, DialogButtons.Cancel], marginLeft, marginTop);
    }

    /**
     * Show dialog with buttons Yes and No
     * @param content Content to display. Can be text or some html element
     * @return Returns a JQueryPromise with a DialogResult. The Promise is rejected if the dialog is closed with a click outside the dialog
     */
    showYesNo(content: any, marginLeft?: number, marginTop?: number, zindex?: number): JQueryPromise<DialogResult> {
        return this.show(content, [DialogButtons.Yes, DialogButtons.No], marginLeft, marginTop, zindex);
    }

    /**
     * Show dialog with buttons Yes, No and Cancel
     * @param content Content to display. Can be text or some html element
     * @return Returns a JQueryPromise with a DialogResult. The Promise is rejected if the dialog is closed with a click outside the dialog
     */
    showYesNoCancel(content: any, marginLeft?: number, marginTop?: number): JQueryPromise<DialogResult> {
        return this.show(content, [DialogButtons.Yes, DialogButtons.No, DialogButtons.Cancel], marginLeft, marginTop);
    }

    /**
     * Show dialog
     * @param content Content to display. Can be text or some html element
     * @param buttons The array of the displayed buttons 
     * @return Returns a JQueryPromise with a DialogResult. The Promise is rejected if the dialog is closed with a click outside the dialog
     */
    show(content: any, buttons?: DialogButtons[], marginLeft?: number, marginTop?: number, zindex?: number): JQueryPromise<DialogResult> {
        if (!FixedDialog.openedDialogs) {
            FixedDialog.openedDialogs = [];
        }
        FixedDialog.openedDialogs.push(this);

        this.marginLeft = marginLeft ? marginLeft : 10;
        this.marginTop = marginTop ? marginTop : 0;
        this.zindex = zindex;

        return $.Deferred((deferrer) => {
            this.deferrer = deferrer;
            this.container = document.createElement("div");
            this.container.className = "fixed-dialog-container";

            var __this = this;
            if (!this.modal) {
                this.onWindowClick = (e: MouseEvent) => {
                    if (this.container) {
                        var el = <Element>e.target;
                        while (el != this.container && (el).parentElement) {
                            el = (el).parentElement;
                            if (FixedDialog.openedDialogs.filter(x => x.container == el).length > 0)
                                return;
                        }
                        if (el != this.container) {
                            __this.hide();
                            deferrer.reject();
                        }
                    }
                }
            }
            setTimeout(() => {
                $(window).on("click", this.onWindowClick);
            }, 1);


            this.content = document.createElement("div");
            this.container.appendChild(this.content);
            this.content.className = "fixed-dialog-content";

            let buttonsContainer = document.createElement("div");
            this.container.appendChild(buttonsContainer);
            buttonsContainer.className = "fixed-dialog-buttons";

            let btns = buttons || [];
            for (let btnType of btns) {
                let btn = document.createElement("button");
                buttonsContainer.appendChild(btn);
                btn.className = "btn btn-link";
                btn.type = "button";
                switch (btnType) {
                    case DialogButtons.Cancel:
                        btn.innerText = Resources.Common.cancel;
                        break;
                    case DialogButtons.No:
                        btn.innerText = Resources.Common.no;
                        break;
                    case DialogButtons.Ok:
                        btn.innerText = Resources.Common.ok;
                        break;
                    case DialogButtons.Yes:
                        btn.innerText = Resources.Common.yes;
                        break;
                }
                let btnType1 = btnType;
                btn.addEventListener("click", (e) => {
                    this.deferrer = undefined;
                    switch (btnType1) {
                        case DialogButtons.Cancel:
                            deferrer.resolve(DialogResult.Cancel);
                            break;
                        case DialogButtons.No:
                            deferrer.resolve(DialogResult.No);
                            break;
                        case DialogButtons.Ok:
                            deferrer.resolve(DialogResult.Ok);
                            break;
                        case DialogButtons.Yes:
                            deferrer.resolve(DialogResult.Yes);
                            break;
                    }
                    this.hide();
                    e.stopPropagation();
                });
            }

            let parent: HTMLElement;
            this.parentContainer = undefined;
            if (this.modal) {
                parent = document.createElement("div");
                parent.className = "modal-container";
                document.getElementsByTagName("body")[0].appendChild(parent);
                this.parentContainer = parent;

            }
            else {
                parent = document.getElementsByTagName("body")[0];
            }

            if (typeof content == "string") {
                let divText = document.createElement("div");
                divText.innerText = content.toString();
                this.content.appendChild(divText);
            }
            else {
                this.showContent = content;
                this.showContentParent = (<Element>content).parentElement;
                this.content.appendChild(content);
            }

            parent.appendChild(this.container);
            this.setPosition();

        }).promise();
    }

    /** Set position of dialog. 
     * Can be called from outside of FixedDialog class to adjust the position */
    setPosition() {
        if (this.container) {
            if (this.toElement) {
                let rect = this.toElement.getBoundingClientRect();
                if (rect.bottom + this.marginTop + this.container.clientHeight <= window.innerHeight) {
                    this.container.style.top = rect.bottom + this.marginTop + "px";
                }
                else {
                    let top = rect.top - this.marginTop - this.container.clientHeight;
                    if (top < 0)
                        this.container.style.top = "0";
                    else
                        this.container.style.top = top + "px";
                }
                this.container.style.left = rect.left + this.marginLeft + "px";
            }
            else {
                this.container.classList.add("absolute-center");
            }

            if (this.zindex) {
                this.container.style.zIndex = this.zindex.toString();
            }
        }
    }

    /** Close the dialog with resolving of show promise.
     * Can be called from outside of FixedDialog class to close the opened dialog */
    close(result?: DialogResult) {
        if (this.deferrer) {
            this.deferrer.resolve(result);
            this.deferrer = undefined;
            this.hide();
        }
    }

    /** Hide the dialog */
    private hide() {
        if (FixedDialog.openedDialogs) {
            let ind = FixedDialog.openedDialogs.indexOf(this);
            if (ind >= 0) {
                FixedDialog.openedDialogs.splice(ind, 1);
            }
        }

        if (this.showContent) {
            if (this.showContentParent) {
                this.showContentParent.appendChild(this.showContent);
            }
            this.showContent = undefined;
            this.showContentParent = undefined
        }

        if (this.onWindowClick) {
            $(window).off("click", this.onWindowClick);
            this.onWindowClick = undefined;
        }

        if (this.parentContainer)
            this.parentContainer.parentElement?.removeChild(this.parentContainer);
        else if (this.container) {
            this.container.parentElement?.removeChild(this.container);
        }
    }

    static close(result?: DialogResult) {
        if (FixedDialog.openedDialogs && FixedDialog.openedDialogs.length > 0) {
            FixedDialog.openedDialogs[FixedDialog.openedDialogs.length - 1].close(result);
        }
    }
}
